import React, { Component } from "react";
import Select from "react-select";

/**
 * Wrapper do React Select que gerencia o padrão isMounted para prevenir
 * warnings de setState em componentes desmontados.
 * 
 * Fix para: "Warning: setState(...): Can only update a mounted or mounting component"
 * Causa: Promises de asyncOptions resolvem após o componente desmontar
 */
class SelectWrapper extends Component {
    constructor(props) {
        super(props);
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * Wrappeia asyncOptions para verificar se o componente ainda está montado
     * antes de chamar o callback. Previne setState em componentes desmontados.
     */
    wrapAsyncOptions = (asyncOptions) => {
        if (!asyncOptions) return undefined;

        return (input, callback) => {
            const safeCallback = (err, data) => {
                // Só chama o callback se o componente ainda está montado
                if (this._isMounted && typeof callback === "function") {
                    callback(err, data);
                }
            };

            // Chama o asyncOptions original com o callback seguro
            return asyncOptions(input, safeCallback);
        };
    };

    render() {
        const { minWidth, asyncOptions, ...otherProps } = this.props;
        
        // Wrappeia asyncOptions se existir
        const wrappedAsyncOptions = this.wrapAsyncOptions(asyncOptions);

        return (
            <Select 
                {...otherProps}
                asyncOptions={wrappedAsyncOptions}
            />
        );
    }
}

export default SelectWrapper;
